import React from 'react';
import { ReactComponent as PlayIcon } from '../assets/play.svg';

export default function RecordGame() {
  return (
    <div className='header__record-game'>
      <PlayIcon />
    </div>
  );
}
